<template>
  <div>
    <b-card no-body>
      <b-card-body>
        <b-row>
          <b-col md="6">
            <b-button variant="success" @click="$router.push({ name: 'new' })" :disabled="isPresented">
              <feather-icon icon="FileIcon" class="mr-50" />
              <span class="align-middle">Nuevo</span>
            </b-button>
          </b-col>
          <b-col md="6">
            <b-button class="float-right" variant="danger" @click="presentRequest" :disabled="isPresented">
              <feather-icon icon="LockIcon" class="mr-50" />
              <span class="align-middle">Presentar</span>
            </b-button>
            <b-button style="margin-right: 1%;" class="float-right" variant="primary" @click="clone"
              :disabled="(isClonned || isPresented)">
              <feather-icon icon="CopyIcon" class="mr-50" />
              <span class="align-middle">Clonar</span>
            </b-button>
          </b-col>
        </b-row>
      </b-card-body>
    </b-card>
    <b-card no-body>
      <div style="display:block" id="listaRequests">
        <b-card-body>
          <div class="d-flex justify-content-between  flex-wrap">
            <!-- filter -->
            <b-form-group label-for="filterInput" class="mb-0">
              <b-input-group size="sm">
                <b-form-input id="filterInput" v-model="filter" type="search" placeholder="Buscar" />
                <b-input-group-append>
                  <b-button :disabled="!filter" @click="filter = ''">
                    Borrar
                  </b-button>
                </b-input-group-append>
              </b-input-group>
            </b-form-group>
          </div>
        </b-card-body>
        <b-table responsive class="position-relative" :busy="isLoading" :per-page="perPage" :current-page="currentPage"
          :items="items" :small="true" :fields="fields" :sort-by.sync="sortBy" :sort-desc.sync="sortDesc"
          :sort-direction="sortDirection" :filter="filter" :filter-included-fields="filterOn" @filtered="cPaginacion">
          <template #cell(actions)="data">
            <div v-if="!isPresented">
              <div class="text-nowrap">
                <feather-icon :id="`${data.item.id}-edit-icon`" icon="EditIcon" class="cursor-pointer" size="16"
                  @click="$router.push({ name: 'edit', params: { id: data.item.id } })" />
                <b-tooltip title="Editar puesto" class="cursor-pointer" :target="`${data.item.id}-edit-icon`" />
              </div>
              <div class="text-nowrap">
                <feather-icon :id="`${data.item.id}-delete-icon`" icon="DeleteIcon" class="cursor-pointer" size="16"
                  @click="deleteRequest(data.item.id)" />
                <b-tooltip title="Eliminar puesto" class="cursor-pointer" :target="`${data.item.id}-delete-icon`" />
              </div>
            </div>
            <div v-else>
              <div class="text-nowrap">
                <feather-icon :id="`${data.item.id}-view-icon`" icon="EyeIcon" class="cursor-pointer" size="16"
                  @click="$router.push({ name: 'presented', params: { id: data.item.id } })" />
                <b-tooltip title="Ver puesto" class="cursor-pointer" :target="`${data.item.id}-view-icon`" />
              </div>
            </div>
          </template>
          <template #cell(joining_type)="data">
            <div v-if="data.item.joining_type == 'Reducción de posición'">
              <del>{{ data.item.joining_type }}</del>
            </div>
            <div v-else>
              {{ data.item.joining_type }}
            </div>
          </template>
          <template #table-busy>
            <div class="text-center text-danger my-2">
              <b-spinner class="align-middle"></b-spinner>
              <strong>Loading...</strong>
            </div>
          </template>
        </b-table>
        <b-card-body class="d-flex justify-content-between flex-wrap pt-0">
          <!-- page length -->
          <b-form-group label="Mostrar" label-cols="5" label-align="left" label-size="sm" label-for="sortBySelect"
            class="text-nowrap mb-md-0 mr-1">
            <b-form-select id="perPageSelect2" v-model="perPage" size="sm" inline :options="pageOptions" />
          </b-form-group>
          <!-- pagination -->
          <div>
            <b-pagination v-model="currentPage" :total-rows="totalRows" :per-page="perPage" first-number last-number
              prev-class="prev-item" next-class="next-item" class="mb-0">
              <template #prev-text>
                <feather-icon icon="ChevronLeftIcon" size="18" />
              </template>
              <template #next-text>
                <feather-icon icon="ChevronRightIcon" size="18" />
              </template>
            </b-pagination>
          </div>
        </b-card-body>
      </div>
    </b-card>
  </div>
</template>

<script>
import axiosIns from '../../libs/axios'
import Ripple from 'vue-ripple-directive'
import vSelect from 'vue-select'

import {
  BCard,
  BTable,
  BFormGroup,
  BFormSelect,
  BPagination,
  BInputGroup,
  BFormInput,
  BInputGroupAppend,
  BButton,
  BCardBody,
  BModal,
  VBModal,
  BRow,
  BCol,
  BProgress,
  BTooltip,
  BSpinner,
} from 'bootstrap-vue'

export default {
  components: {
    BCard,
    BTable,
    BFormGroup,
    BFormSelect,
    BPagination,
    BInputGroup,
    BFormInput,
    BInputGroupAppend,
    BButton,
    BCardBody,
    BModal,
    BRow,
    BCol,
    BProgress,
    BTooltip,
    vSelect,
    BSpinner,
  },
  directives: {
    'b-modal': VBModal,
    Ripple,
  },
  data() {
    return {
      perPage: 10,
      pageOptions: [5, 10, 15],
      totalRows: 1,
      currentPage: 1,
      sortBy: '',
      sortDesc: false,
      sortDirection: 'asc',
      filter: null,
      filterOn: [],
      fields: [
        {
          key: 'id',
          label: 'ID',
          sortable: true,
        },
        {
          key: 'budget_year',
          label: 'Año Ppto',
          sortable: true,
        },
        {
          key: 'budget_code',
          label: 'Código Ppto',
          sortable: true,
        },
        {
          key: 'payroll_type',
          label: 'Tipo de Planilla',
          sortable: true,
        },
        {
          key: 'company',
          label: 'Empresa',
          sortable: true,
        },

        {
          key: 'joining_type',
          label: 'Tipo de Ingreso',
          sortable: true,
        },
        {
          key: 'position',
          label: 'Puesto',
          sortable: true,
        },
        {
          key: 'department',
          label: 'Departamento',
          sortable: true,
        },
        {
          key: 'area',
          label: 'Área',
          sortable: true,
        },
        {
          key: 'section',
          label: 'Sección',
          sortable: true,
        },
        {
          key: 'actions',
          label: 'Acciones',
        },
      ],
      items: [],
      isPresented: true,
      isClonned: false,
      isLoading: true,
    }
  },
  computed: {
    sortOptions() {
      // Create an options list from our fields
      return this.fields
        .filter(f => f.sortable)
        .map(f => ({
          text: f.label,
          value: f.key,
        }))
    },
  },
  mounted() {
    this.getRequests()
    this.checkIfPresented()
    this.checkIfClonned()
  },
  methods: {
    cPaginacion(filteredItems) {
      this.totalRows = filteredItems.length
      this.currentPage = 1
    },
    getRequests() {
      const URL = '/nomina/get_requests'
      const config = {
        method: 'get',
        url: URL,
        params: {
          user_id: this.getUserID(),
          app_user_id: this.getUserID(),
        },
      }
      this.isLoading = true
      axiosIns(config)
        .then(response => {
          if (response && response.status === 200) {
            let newList = []
            let newElement = {}
            for (let element of response.data.response) {
              newElement = { ...element, _rowVariant: element['joining_type'] == 'Reducción de posición' ? 'danger' : '' }
              newList.push(newElement)
            }
            this.isLoading = false
            this.items = newList
            this.totalRows = newList.length
          }
        })
        .catch(error => {
          this.isLoading = false
          this.printErrorModal(error)
        });
    },
    getUserID() {
      const textUserData = localStorage.getItem('userData')
      const jsonUserData = JSON.parse(textUserData)
      const id = jsonUserData.id
      return id
    },
    presentRequest() {
      this.$swal({
        title: '¿Estas seguro?',
        text: "No podrás revertir esta acción",
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: 'Sí, presentar solicitud',
        customClass: {
          confirmButton: 'btn btn-primary',
          cancelButton: 'btn btn-outline-danger ml-1',
        },
        buttonsStyling: false,
      }).then(result => {
        if (result.value) {
          // Send data to server
          const URL = '/nomina/present'
          const config = {
            method: 'post', url: URL, data: { user_id: this.getUserID(), app_user_id: this.getUserID() },
          }
          axiosIns(config)
            .then(response => {
              if (response && response.status === 200) {
                this.$swal({
                  icon: 'success',
                  title: '¡Guardado!',
                  text: 'Las solicitudes han sido presentadas',
                  customClass: {
                    confirmButton: 'btn btn-success',
                  },
                }).then(x => this.$router.go())
              } else {
                this.printErrorModal('Error en el servidor')
              }
            })
            .catch(error => {
              this.printErrorModal(error)
            });
        }
      })
    },
    clone() {
      this.$swal({
        title: '¿Estas seguro?',
        text: 'No podrás revertir esta acción',
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: 'Sí, presentar solicitud',
        customClass: {
          confirmButton: 'btn btn-primary',
          cancelButton: 'btn btn-outline-danger ml-1',
        },
        buttonsStyling: false,
      }).then(result => {
        if (result.value) {
          // Send data to server
          const URL = '/nomina/clone'
          const config = {
            method: 'post',
            url: URL,
            data: {
              user_id: this.getUserID(),
              app_user_id: this.getUserID(),
            },
          }
          axiosIns(config)
            .then(response => {
              if (response && response.status === 200) {
                this.$swal({
                  icon: 'success',
                  title: '¡Guardado!',
                  text: 'La puestos del ańo pasado han sido clonados',
                  customClass: {
                    confirmButton: 'btn btn-success',
                  },
                }).then(x => this.$router.go())
              } else {
                this.printErrorModal('Error en el servidor')
              }
            })
            .catch(error => {
              this.printErrorModal(error)
            })
        }
      })
    },
    checkIfClonned() {
      const URL = '/nomina/is_clonned'
      const config = {
        method: 'get', url: URL, params: {
          user_id: this.getUserID(),
          app_user_id: this.getUserID(),
        },
      }
      axiosIns(config)
        .then(response => {
          if (response && response.status === 200) {
            this.isClonned = response.data.response
          }
        })
        .catch(error => {
          this.printErrorModal(error)
        });
    },
    checkIfPresented() {
      const URL = '/nomina/is_presented'
      const config = {
        method: 'get', url: URL, params: {
          user_id: this.getUserID(),
          app_user_id: this.getUserID(),
        },
      }
      axiosIns(config)
        .then(response => {
          if (response && response.status === 200) {
            this.isPresented = response.data.response
          }
        })
        .catch(error => {
          this.printErrorModal(error)
        });
    },
    printErrorModal(error) {
      this.$swal({
        title: 'Error!',
        text: error,
        icon: 'error',
        customClass: {
          confirmButton: 'btn btn-primary',
        },
        buttonsStyling: false,
      })
    },
    deleteRequest(requestId) {
      this.$swal({
        title: '¿Estas seguro?',
        text: 'No podrás revertir esta acción',
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: 'Sí, eliminar registro de solicitud',
        customClass: {
          confirmButton: 'btn btn-primary',
          cancelButton: 'btn btn-outline-danger ml-1',
        },
        buttonsStyling: false,
      }).then(result => {
        if (result.value) {
          // Send data to server
          const URL = '/nomina/request/delete'
          const config = {
            method: 'post', url: URL, data: { user_id: this.getUserID(), app_user_id: this.getUserID(), request_id: requestId },
          }
          console.log(config)
          axiosIns(config)
            .then(response => {
              if (response && response.status === 200) {
                this.$swal({
                  icon: 'success',
                  title: '¡Eliminado!',
                  text: 'La solicitud ha sido eliminada',
                  customClass: {
                    confirmButton: 'btn btn-success',
                  },
                }).then(x => this.$router.go())
              } else {
                this.printErrorModal('Error en el servidor')
              }
            })
            .catch(error => {
              this.printErrorModal(error)
            })
        }
      })
    },
  },
}
</script>

<style lang="scss">
@import '@core/scss/vue/libs/vue-select.scss';
@import '@core/scss/vue/libs/vue-flatpicker.scss';
</style>
